function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Link } from "@custom/schema";
import React from "react";
import { useIntl } from "../../utils/intl";
import { isTruthy } from "../../utils/isTruthy";
import { buildNavigationTree } from "../../utils/navigation";
import { DesktopMenu, DesktopMenuDropDown } from "../Client/DesktopMenu";
import { MobileMenu, MobileMenuButton, MobileMenuDropdown, MobileMenuLink, MobileMenuProvider } from "../Client/MobileMenu";
import { ArrowIcon, LinkIcon, Logo } from "../Molecules/icons";
export default function Header(props) {
    return /*#__PURE__*/ React.createElement(MobileMenuProvider, null, /*#__PURE__*/ React.createElement("header", null, /*#__PURE__*/ React.createElement("nav", {
        "aria-label": "Global"
    }, /*#__PURE__*/ React.createElement(DesktopHeader, props), /*#__PURE__*/ React.createElement(MobileHeader, props))));
}
var DesktopHeader = function(param) {
    var mainNavigation = param.mainNavigation, topNavigation = param.topNavigation, metaNavigation = param.metaNavigation;
    var intl = useIntl();
    var items = buildNavigationTree(mainNavigation.items.filter(isTruthy));
    var meta = metaItems(metaNavigation);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "hidden lg:block relative"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "flex items-center justify-end gap-8 py-3 bg-gray-200 container-page"
    }, topNavigation.items.filter(isTruthy).map(function(item, key) {
        return /*#__PURE__*/ React.createElement("li", {
            key: key
        }, /*#__PURE__*/ React.createElement(Link, {
            key: key,
            href: item.target,
            className: "text-sm leading-sm text-gray-500 hover:text-black transition-all focus-dark"
        }, item.title));
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "hidden lg:flex items-center justify-between container-page py-5"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "/",
        className: "focus-dark"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "University of St.Gallen logo",
        id: "P4rQqC"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-[15.8125rem] mb-7 "
    }, /*#__PURE__*/ React.createElement(Logo, {
        width: "253",
        height: "52",
        variant: "primary"
    }))), /*#__PURE__*/ React.createElement("ul", {
        className: "flex gap-5 items-center"
    }, /*#__PURE__*/ React.createElement(DesktopMenu, null, items.map(function(item, key) {
        return item.children.length === 0 ? /*#__PURE__*/ React.createElement("li", {
            key: key
        }, /*#__PURE__*/ React.createElement(Link, {
            key: key,
            href: item.target,
            className: "link-main-navigation focus-dark"
        }, item.title)) : /*#__PURE__*/ React.createElement(DesktopMenuDropDown, {
            title: item.title,
            key: key
        }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            key: item.title,
            href: item.target,
            className: "flex flex-row flex-1 rounded-lg py-2 px-3 text-sm font-semibold hover:bg-green-500/10 items-center gap-4 focus-dark"
        }, /*#__PURE__*/ React.createElement(ArrowIcon, null), item.title)), item.children.map(function(child) {
            return /*#__PURE__*/ React.createElement("li", {
                key: key
            }, /*#__PURE__*/ React.createElement(Link, {
                key: child.target,
                href: child.target,
                className: "block rounded-lg py-2 px-3 text-sm font-semibold hover:bg-green-500/10 focus-dark"
            }, child.title));
        }));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "hidden lg:flex gap-x-4 items-center"
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: meta[0].url,
        className: "button-navigation-primary text-2xs leading-sm font-semibold focus-dark"
    }, meta[0].title)), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: meta[1].url,
        className: "button-navigation-secondary text-2xs leading-sm font-semibold focus-dark"
    }, meta[1].title))))));
};
var MobileHeader = function(param) {
    var mainNavigation = param.mainNavigation, topNavigation = param.topNavigation, metaNavigation = param.metaNavigation;
    var intl = useIntl();
    var items = buildNavigationTree(mainNavigation.items.filter(isTruthy));
    var meta = metaItems(metaNavigation);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex lg:hidden container-page items-center justify-between py-7 border-white/20"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "/",
        className: "focus-dark"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "University of St.Gallen logo",
        id: "P4rQqC"
    })), /*#__PURE__*/ React.createElement(Logo, {
        variant: "primary",
        className: "h-10 sm:h-12 w-auto"
    })), /*#__PURE__*/ React.createElement(MobileMenuButton, null)), /*#__PURE__*/ React.createElement(MobileMenu, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-between py-7 border-b-[1px] border-white/20"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "#",
        className: "focus-white"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "University of St.Gallen logo",
        id: "P4rQqC"
    })), /*#__PURE__*/ React.createElement(Logo, {
        variant: "secondary",
        className: "h-10 sm:h-12 w-auto"
    })), /*#__PURE__*/ React.createElement(MobileMenuButton, null)), /*#__PURE__*/ React.createElement("div", {
        className: "flow-root divide-y divide-white/20 pt-4"
    }, /*#__PURE__*/ React.createElement("ul", null, items.map(function(item) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, item.children.length === 0 ? /*#__PURE__*/ React.createElement("li", {
            key: item.title
        }, /*#__PURE__*/ React.createElement(Link, {
            key: item.title,
            href: item.target,
            className: "flex py-3 text-lg leading-lg text-white hover:bg-white/20 w-screen -mx-[1.25rem] px-[1.25rem] focus:bg-white/2 focus-white"
        }, item.title)) : /*#__PURE__*/ React.createElement(MobileMenuDropdown, {
            title: item.title,
            key: item.title
        }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            key: item.title,
            href: item.target,
            className: "text-lg leading-lg font-semibold text-white hover:bg-black/20 inline-block px-1 focus:bg-white/2 focus-white"
        }, /*#__PURE__*/ React.createElement(ArrowIcon, {
            className: "inline-block me-4"
        }), item.title)), item.children.map(function(child) {
            return /*#__PURE__*/ React.createElement("li", {
                key: "".concat(item.title, "-").concat(child.title)
            }, /*#__PURE__*/ React.createElement(MobileMenuLink, {
                key: child.target,
                href: child.target,
                title: child.title
            }));
        })));
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-start pb-7"
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: meta[0].url,
        className: "link-external-navigation focus-white"
    }, meta[0].title, /*#__PURE__*/ React.createElement(LinkIcon, null))), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: meta[1].url,
        className: "link-external-navigation focus-white"
    }, meta[1].title, /*#__PURE__*/ React.createElement(LinkIcon, null))))), /*#__PURE__*/ React.createElement("ul", {
        className: "pt-5"
    }, topNavigation.items.filter(isTruthy).map(function(item) {
        return /*#__PURE__*/ React.createElement("li", {
            key: item.title
        }, /*#__PURE__*/ React.createElement(Link, {
            key: item.title,
            href: item.target,
            className: "block py-3 text-lg leading-lg font-normal text-white hover:bg-white/20 w-screen -mx-[1.25rem] px-[1.25rem] focus:bg-white/20 focus-white"
        }, item.title));
    })))));
};
function metaItems(metaNavigation) {
    var _metaNavigation_items_filter_map = _sliced_to_array(metaNavigation.items.filter(isTruthy).map(function(item) {
        return {
            title: item.title,
            url: item.target
        };
    }), 2), first = _metaNavigation_items_filter_map[0], second = _metaNavigation_items_filter_map[1];
    // TODO: Remove this once the menu is corrected on Drupal side.
    //  Currently its title is too long for the new design.
    if (second && second.title.length > "Apply and more".length) {
        second.title = "Apply";
    }
    return [
        first || {
            title: "Download brochure",
            url: "https://apply.mba.unisg.ch/f/54aabbf554fc5e2f11000045"
        },
        second || {
            title: "Apply",
            url: "https://apply.mba.unisg.ch/login"
        }
    ];
}
